import { useApplicationContext } from '@interhyp/util-application-context';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getMandantData } from '../redux/MandantConfig/selectors';

// TODO: migrate addPermission to `usePermissionContext` when implemented
export function useWatchPermissions(): void {
  const { addPermission } = useApplicationContext();

  const data = useSelector(getMandantData);

  useEffect(() => {
    if (data?.config) {
      const permissions = Object.entries(data.config).reduce<string[]>(
        (carry, [permission, bool]) => (bool ? [...carry, permission] : carry),
        [],
      );

      addPermission?.(permissions);
    }
  }, [addPermission, data]);
}
